export const USER_LEVELS = {
    SUPER_ADMIN: "1",
    VIEWER: "2",
    OPERATOR: "3",
    FINANCE: "4",
    INVENTORY_ADMIN: "5",
    MANAGER: "6",
    LEVEL_7: "7", // Customer/Importir
};

export const MODULES = {
    DASHBOARD: "dashboard",
    // Monitoring dipecah menjadi 3 sub-modul
    MONITORING_CCTV: "monitoring_cctv",
    MONITORING_STOCK: "monitoring_stock",
    MONITORING_USER_ACTIVITY: "monitoring_user_activity",
    MONITORING_ANTI_FRAUD: "monitoring_anti_fraud",
    CUSTOMS: "customs",
    INVENTORY: "inventory",
    PITA_CUKAI: "pita_cukai",
    FINANCE: "finance",
    PORTAL: "portal",
    REFERENSI: "referensi",
    OTHERS: "others",
    EMAIL: "email",
    USER: "user",
    ROLE_ACCESS: "role_access"
};

export const getUserLevel = () => {
    try {
        const userStr = localStorage.getItem("user");
        if (!userStr) return null;
        const user = JSON.parse(userStr);
        return String(user.id_user_level);
    } catch (e) {
        console.error("Error parsing user from localStorage", e);
        return null;
    }
};

/**
 * Get permissions from localStorage
 */
const getPermissions = () => {
    try {
        const permsStr = localStorage.getItem("permissions");
        return permsStr ? JSON.parse(permsStr) : [];
    } catch (e) {
        console.error("Error parsing permissions from localStorage", e);
        return [];
    }
};

/**
 * Check if user has access to a module (can_read permission)
 */
export const hasAccess = (module) => {
    const level = getUserLevel();
    if (!level) return false;

    // Super Admin has access to everything
    if (level === USER_LEVELS.SUPER_ADMIN) return true;

    // Check dynamic permissions from database
    const permissions = getPermissions();
    const modulePerm = permissions.find(p => p.menu_key === module);

    return modulePerm && modulePerm.can_read === 1;
};

/**
 * Check if user can create/insert in a module
 */
export const canCreate = (module) => {
    const level = getUserLevel();
    if (!level) return false;

    // Super Admin can do everything
    if (level === USER_LEVELS.SUPER_ADMIN) return true;

    // Check dynamic permissions
    const permissions = getPermissions();
    const modulePerm = permissions.find(p => p.menu_key === module);

    return modulePerm && modulePerm.can_create === 1;
};

/**
 * Check if user can edit/update in a module
 */
export const canEdit = (module) => {
    const level = getUserLevel();
    if (!level) return false;

    // Super Admin can do everything
    if (level === USER_LEVELS.SUPER_ADMIN) return true;

    // Check dynamic permissions
    const permissions = getPermissions();
    const modulePerm = permissions.find(p => p.menu_key === module);

    return modulePerm && modulePerm.can_update === 1;
};

/**
 * Check if user can delete in a module
 */
export const canDelete = (module) => {
    const level = getUserLevel();
    if (!level) return false;

    // Super Admin can do everything
    if (level === USER_LEVELS.SUPER_ADMIN) return true;

    // Check dynamic permissions
    const permissions = getPermissions();
    const modulePerm = permissions.find(p => p.menu_key === module);

    return modulePerm && modulePerm.can_delete === 1;
};
